import { createSlice } from '@reduxjs/toolkit'

// Setup the initial state

const initialState = {
  consultClientsMis: {},
  consultClientsFile: {},
  consultClientsMisSpouse: {},
  consultClientsMisRepresentative: {},
  registerClient: {},
  registerClientSpouse: {},
  registerClientRepresentative: {},
  updateNaturalClient: {},
  insertClientInBackOffice: {},
  uploadClientFilesToBackOffice: {},
  incomeDeclarationPDF: {},
};

export const clientsSlice = createSlice({
  name: 'clients',
  initialState,
  reducers: {

    // Consult Clients Mis

    setConsultClientsMisLoading: (state) => {
      state.consultClientsMis = {
        isLoading: true,
      };
    },

    setConsultClientsMisSuccess: (state, action) => {
      state.consultClientsMis = {
        data: action.payload
      };
    },

    setConsultClientsMisFailure: (state, action) => {
      state.consultClientsMis = {
        error: action.payload,
      }
    },

    cleanUpConsultClientsMis: (state) => {
      state.consultClientsMis = {}
    },


    // Consult Client File

    setConsultClientsFileLoading: (state) => {
      state.consultClientsFile = {
        isLoading: true,
      };
    },

    setConsultClientsFileSuccess: (state, action) => {
      state.consultClientsFile = {
        data: action.payload
      };
    },

    setConsultClientsFileFailure: (state, action) => {
      state.consultClientsFile = {
        error: action.payload,
      }
    },

    cleanUpConsultClientsFile: (state) => {
      state.consultClientsFile = {}
    },


    // Consult Clients Mis Spouse

    setConsultClientsMisSpouseLoading: (state) => {
      state.consultClientsMisSpouse = {
        isLoading: true,
      };
    },

    setConsultClientsMisSpouseSuccess: (state, action) => {
      state.consultClientsMisSpouse = {
        data: action.payload
      };
    },

    setConsultClientsMisSpouseFailure: (state, action) => {
      state.consultClientsMisSpouse = {
        error: action.payload,
      }
    },

    cleanUpConsultClientsMisSpouse: (state) => {
      state.consultClientsMisSpouse = {}
    },


    // Consult Clients Mis Representative

    setConsultClientsMisRepresentativeLoading: (state) => {
      state.consultClientsMisRepresentative = {
        isLoading: true,
      };
    },

    setConsultClientsMisRepresentativeSuccess: (state, action) => {
      state.consultClientsMisRepresentative = {
        data: action.payload
      };
    },

    setConsultClientsMisRepresentativeFailure: (state, action) => {
      state.consultClientsMisRepresentative = {
        error: action.payload,
      }
    },

    cleanUpConsultClientsMisRepresentative: (state) => {
      state.consultClientsMisRepresentative = {}
    },


    // Register Client

    setRegisterClientLoading: (state) => {
      state.registerClient = {
        isLoading: true,
      };
    },

    setRegisterClientSuccess: (state, action) => {
      state.registerClient = {
        success: true,
        data: action.payload
      };
    },

    setRegisterClientFailure: (state, action) => {
      state.registerClient = {
        error: action.payload,
      }
    },

    clearRegisterClient: (state) => {
      state.registerClient = {}
    },


    // Register Client Spouse

    setRegisterClientSpouseLoading: (state) => {
      state.registerClientSpouse = {
        isLoading: true,
      };
    },

    setRegisterClientSpouseSuccess: (state, action) => {
      state.registerClientSpouse = {
        success: true,
        data: action.payload
      };
    },

    setRegisterClientSpouseFailure: (state, action) => {
      state.registerClientSpouse = {
        error: action.payload,
      }
    },

    clearRegisterClientSpouse: (state) => {
      state.registerClientSpouse = {}
    },


    // Register Client Representative

    setRegisterClientRepresentativeLoading: (state) => {
      state.registerClientRepresentative = {
        isLoading: true,
      };
    },

    setRegisterClientRepresentativeSuccess: (state, action) => {
      state.registerClientRepresentative = {
        success: true,
        data: action.payload
      };
    },

    setRegisterClientRepresentativeFailure: (state, action) => {
      state.registerClientRepresentative = {
        error: action.payload,
      }
    },

    clearRegisterClientRepresentative: (state) => {
      state.registerClientRepresentative = {}
    },


    // Update Natural Client Details

    setUpdateNaturalClientLoading: (state) => {
      state.updateNaturalClient = {
        isLoading: true,
      };
    },

    setUpdateNaturalClientSuccess: (state, action) => {
      state.updateNaturalClient = {
        isUpdated: true,
        data: action.payload
      };
    },

    setUpdateNaturalClientFailure: (state, action) => {
      state.updateNaturalClient = {
        error: action.payload,
      }
    },

    clearUpdateNaturalClientStore: (state) => {
      state.updateNaturalClient = {}
    },


    // Insert Registered Client In Backoffice 

    setInsertClientInBackOfficeLoading: (state) => {
      state.insertClientInBackOffice = {
        isLoading: true,
      };
    },

    setInsertClientInBackOfficeSuccess: (state, action) => {
      state.insertClientInBackOffice = {
        success: true,
      };
    },

    setInsertClientInBackOfficeFailure: (state, action) => {
      state.insertClientInBackOffice = {
        error: action.payload,
      }
    },

    clearInsertClientInBackOfficeStore: (state) => {
      state.insertClientInBackOffice = {}
    },


    // Insert Registered Client In Backoffice 

    setUploadClientFilesToBackOfficeLoading: (state) => {
      state.uploadClientFilesToBackOffice = {
        isLoading: true,
      };
    },

    setUploadClientFilesToBackOfficeSuccess: (state, action) => {
      state.uploadClientFilesToBackOffice = {
        success: true,
      };
    },

    setUploadClientFilesToBackOfficeFailure: (state, action) => {
      state.uploadClientFilesToBackOffice = {
        error: action.payload,
      }
    },

    clearUploadClientFilesToBackOfficeStore: (state) => {
      state.uploadClientFilesToBackOffice = {}
    },


    // Generate PDF of Income Declaration 

    setIncomeDeclarationPDFLoading: (state) => {
      state.incomeDeclarationPDF = {
        isLoading: true,
      };
    },

    setIncomeDeclarationPDFSuccess: (state, action) => {
      state.incomeDeclarationPDF = {
        data: action.payload
      };
    },

    setIncomeDeclarationPDFFailure: (state, action) => {
      state.incomeDeclarationPDF = {
        error: action.payload,
      }
    },

    cleanUpIncomeDeclarationPDF: (state) => {
      state.incomeDeclarationPDF = {}
    },

  },
})

export const {
  setConsultClientsMisLoading, setConsultClientsMisSuccess, setConsultClientsMisFailure, cleanUpConsultClientsMis,
  setConsultClientsFileLoading, setConsultClientsFileSuccess, setConsultClientsFileFailure, cleanUpConsultClientsFile,
  setConsultClientsMisSpouseLoading, setConsultClientsMisSpouseSuccess, setConsultClientsMisSpouseFailure, cleanUpConsultClientsMisSpouse,
  setConsultClientsMisRepresentativeLoading, setConsultClientsMisRepresentativeSuccess, setConsultClientsMisRepresentativeFailure, cleanUpConsultClientsMisRepresentative,
  setRegisterClientLoading, setRegisterClientSuccess, setRegisterClientFailure, clearRegisterClient,
  setRegisterClientSpouseLoading, setRegisterClientSpouseSuccess, setRegisterClientSpouseFailure, clearRegisterClientSpouse,
  setRegisterClientRepresentativeLoading, setRegisterClientRepresentativeSuccess, setRegisterClientRepresentativeFailure, clearRegisterClientRepresentative,
  setUpdateNaturalClientLoading, setUpdateNaturalClientSuccess, setUpdateNaturalClientFailure, clearUpdateNaturalClientStore,
  setInsertClientInBackOfficeLoading, setInsertClientInBackOfficeSuccess, setInsertClientInBackOfficeFailure, clearInsertClientInBackOfficeStore,
  setUploadClientFilesToBackOfficeLoading, setUploadClientFilesToBackOfficeSuccess, setUploadClientFilesToBackOfficeFailure, clearUploadClientFilesToBackOfficeStore,
  setIncomeDeclarationPDFLoading, setIncomeDeclarationPDFSuccess, setIncomeDeclarationPDFFailure, cleanUpIncomeDeclarationPDF
} = clientsSlice.actions

export default clientsSlice.reducer;